import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export default function MentionsLegales() {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <motion.div {...fadeInUp}>
          <Button
            variant="ghost"
            className="mb-8"
            asChild
          >
            <a href="/">
              <ArrowLeft className="mr-2 w-4 h-4" />
              Retour à l'accueil
            </a>
          </Button>

          <h1 className="text-4xl md:text-5xl font-black mb-8">Mentions Légales</h1>

          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-4">Éditeur du site</h2>
            <div className="space-y-2 text-muted-foreground">
              <p><strong className="text-foreground">Dénomination :</strong> VEHORIA (VEHORIA ACADEMY)</p>
              <p><strong className="text-foreground">Forme juridique :</strong> Société à responsabilité limitée</p>
              <p><strong className="text-foreground">Siège social :</strong> 60 rue François Ier, 75008 PARIS</p>
              <p><strong className="text-foreground">Téléphone :</strong> +33 6 04 41 76 82</p>
              <p><strong className="text-foreground">Email :</strong> contact@lorishug.fr</p>
              <p><strong className="text-foreground">SIREN :</strong> 988 977 260</p>
              <p><strong className="text-foreground">SIRET :</strong> 988 977 260 00013</p>
              <p><strong className="text-foreground">Code NAF/APE :</strong> 85.59B - Autres enseignements</p>
              <p><strong className="text-foreground">TVA Intracommunautaire :</strong> FR67988977260</p>
              <p><strong className="text-foreground">Directeur de la publication :</strong> Camille Vega De Hoyos</p>
              <p><strong className="text-foreground">Responsable éditorial :</strong> Loris Hug</p>
            </div>
          </Card>

          <Card className="p-8 mb-8">
            <h2 className="text-2xl font-bold mb-4">Hébergement</h2>
            <div className="space-y-2 text-muted-foreground">
              <p><strong className="text-foreground">Hébergeur :</strong> Vercel Inc.</p>
              <p><strong className="text-foreground">Adresse :</strong> 340 S Lemon Ave #4133, Walnut, CA 91789, USA</p>
            </div>
          </Card>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-2xl font-bold mb-4 mt-8">Conditions Générales de Vente</h2>
            <p className="text-sm text-muted-foreground mb-6">Date de dernière mise à jour : 29/03/2023</p>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">PRÉAMBULE</h3>
              <p className="text-muted-foreground leading-relaxed">
                Les présentes conditions générales régissent les ventes conclues entre le vendeur et société VEHORIA et toute personne souhaitant procéder à un achat via le présent site internet, ci-après, l'acheteur. En validant sa commande, le Client déclare accepter sans réserve les termes de celle-ci ainsi que l'intégralité des présentes conditions générales de vente et déclare avoir la capacité de conclure un contrat avec le vendeur.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">1. OBJET</h3>
              <p className="text-muted-foreground leading-relaxed">
                Les présentes conditions de vente visent à définir les relations contractuelles entre le vendeur et l'acheteur ainsi que les conditions applicables à tout achat effectué par le biais du présent site marchand. Les présentes conditions de vente prévaudront sur toutes autres conditions générales ou particulières non expressément agréées par le vendeur. Le vendeur se réserve la possibilité de modifier ses conditions générales de vente à tout moment sans préavis : les conditions applicables seront celles en vigueur à la date de la commande par l'acheteur.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">2. CARACTÉRISTIQUES DES BIENS ET SERVICES PROPOSÉS</h3>
              <p className="text-muted-foreground leading-relaxed">
                Les produits ou services proposés sont ceux qui sont présentés sur le présent site marchand et qui sont accompagnés d'un descriptif détaillé. Ces produits et services sont proposés dans la limite des stocks disponibles et tant qu'ils sont visibles sur le site. En cas d'indisponibilité du produit ou service après passation de la commande, le vendeur en informera l'acheteur par mail : la commande sera automatiquement annulée et aucun débit ne sera effectué.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">3. TARIFS</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Les prix de nos produits sont indiqués en euros toutes taxes comprises (TVA et autres taxes applicables au jour de la commande), sauf indication contraire et hors frais de traitement et d'expédition.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                En cas de commande vers un pays autre que la France métropolitaine vous êtes l'importateur du ou des produits concernés. Des droits de douane ou autres taxes locales ou droits d'importation ou taxes d'état sont susceptibles d'être exigibles. Ces droits et sommes ne relèvent pas du ressort de la société VEHORIA. Ils seront à votre charge et relèvent de votre entière responsabilité, tant en termes de déclarations que de paiements aux autorités et organismes compétents de votre pays.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Toutes les commandes quelle que soit leur origine sont payables en euros.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                La société VEHORIA se réserve le droit de modifier ses prix à tout moment, mais le produit sera facturé sur la base du tarif en vigueur au moment de la validation de la commande et sous réserve de disponibilité.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Les produits demeurent la propriété de la société VEHORIA jusqu'au paiement complet du prix. Attention : dès que vous prenez possession physiquement des produits commandés, les risques de perte ou d'endommagement des produits vous sont transférés.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">4. COMMANDES</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Vous pouvez passer commande sur Internet : <a href="https://www.lorishug.com" className="text-primary hover:underline">https://www.lorishug.com</a>
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Les informations contractuelles sont présentées en langue française et feront l'objet d'une confirmation au plus tard au moment de la validation de votre commande. La société VEHORIA se réserve le droit de ne pas enregistrer un paiement, et de ne pas confirmer une commande pour quelque raison que ce soit, et plus particulièrement en cas de problème d'approvisionnement, ou en cas de difficulté concernant la commande reçue.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">5. VALIDATION DE VOTRE COMMANDE</h3>
              <p className="text-muted-foreground leading-relaxed">
                Toute commande figurant sur le site Internet suppose l'adhésion aux présentes Conditions Générales. Toute confirmation de commande entraîne votre adhésion pleine et entière aux présentes conditions générales de vente, sans exception ni réserve. L'ensemble des données fournies et la confirmation enregistrée vaudront preuve de la transaction. Vous déclarez en avoir parfaite connaissance.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">6. PAIEMENT</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Le fait de valider votre commande implique pour vous l'obligation de payer le prix indiqué.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Le règlement de vos achats s'effectue par carte bancaire grâce au système sécurisé STRIPE. Le débit de la carte n'est effectué qu'au moment de l'expédition de la commande. En cas de livraisons fractionnées, seuls les produits expédiés sont débités.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">7. LIVRAISON</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Les produits sont livrés à l'adresse de livraison indiquée au cours du processus de commande, dans le délai indiqué sur la page de validation de la commande.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                En cas de retard d'expédition, un mail vous sera adressé pour vous informer d'une éventuelle conséquence sur le délai de livraison qui vous a été indiqué.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                En cas de livraisons par un transporteur, la société VEHORIA ne peut être tenue pour responsable de retard de livraison dû exclusivement à une indisponibilité du client après plusieurs propositions de rendez-vous. Le vendeur se dégage de toute responsabilité en cas d'inexécution du contrat dû à un cas de force majeure (grève, incendie, inondation...).
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">8. RÉTRACTATION</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Conformément aux dispositions de l'article L.121-21 du Code de la Consommation, vous disposez d'un délai de rétractation de 14 jours à compter de la réception de vos produits pour exercer votre droit de rétraction sans avoir à justifier de motifs ni à payer de pénalité.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Les retours sont à effectuer dans leur état d'origine et complets (emballage, accessoires, notice). Dans ce cadre, votre responsabilité est engagée. Tout dommage subi par le produit à cette occasion peut être de nature à faire échec au droit de rétractation.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                En cas d'exercice du droit de rétractation, la société VEHORIA procédera au remboursement des sommes versées, dans un délai de 14 jours suivant la notification de votre demande et via le même moyen de paiement que celui utilisé lors de la commande.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">9. EXCEPTIONS AU DROIT DE RÉTRACTATION</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Conformément aux dispositions de l'article L.121-21-8 du Code de la Consommation, le droit de rétractation ne s'applique pas à :
              </p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>La fourniture de services pleinement exécutés avant la fin du délai de rétractation</li>
                <li>La fourniture de biens confectionnés selon les spécifications du consommateur ou nettement personnalisés</li>
                <li>La fourniture de biens susceptibles de se détériorer ou de se périmer rapidement</li>
                <li>La fourniture d'enregistrements audio ou vidéo ou de logiciels informatiques lorsqu'ils ont été descellés</li>
                <li>La fourniture d'un contenu numérique non fourni sur un support matériel</li>
              </ul>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">10. GARANTIES</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Tous nos produits bénéficient de la garantie légale de conformité et de la garantie des vices cachés, prévues par les articles 1641 et suivants du Code civil. En cas de non-conformité d'un produit vendu, il pourra être retourné, échangé ou remboursé.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Toutes les réclamations, demandes d'échange ou de remboursement doivent s'effectuer par mail dans le délai de 30 jours de la livraison.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">11. RESPONSABILITÉ</h3>
              <p className="text-muted-foreground leading-relaxed">
                Les produits proposés sont conformes à la législation française en vigueur. La responsabilité de la société VEHORIA ne saurait être engagée en cas de non-respect de la législation du pays où le produit est livré. La société VEHORIA ne saurait être tenue pour responsable des dommages résultant d'une mauvaise utilisation du produit acheté.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">12. DONNÉES PERSONNELLES</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">
                La société VEHORIA se réserve le droit de collecter les informations nominatives et les données personnelles vous concernant. Elles sont nécessaires à la gestion de votre commande, ainsi qu'à l'amélioration des services et des informations que nous vous adressons.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Conformément à la loi du 6 janvier 1978, vous disposez d'un droit d'accès, de rectification et d'opposition aux informations nominatives et aux données personnelles vous concernant.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">13. PROPRIÉTÉ INTELLECTUELLE</h3>
              <p className="text-muted-foreground leading-relaxed">
                Tous les éléments du site sont et restent la propriété intellectuelle et exclusive de la société VEHORIA. Nul n'est autorisé à reproduire, exploiter, rediffuser, ou utiliser à quelque titre que ce soit, même partiellement, des éléments du site qu'ils soient logiciels, visuels ou sonores.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">14. DROIT APPLICABLE EN CAS DE LITIGES</h3>
              <p className="text-muted-foreground leading-relaxed">
                Les présentes conditions générales de vente sont soumises à la loi française. La langue du présent contrat est la langue française. En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </Card>

            <Card className="p-6 mb-6">
              <h3 className="text-xl font-bold mb-3">15. ARCHIVAGE PREUVE</h3>
              <p className="text-muted-foreground leading-relaxed">
                La société VEHORIA archivera les bons de commandes et les factures sur un support fiable et durable constituant une copie fidèle conformément aux dispositions de l'article 1348 du Code civil. Les registres informatisés de la société VEHORIA seront considérés par toutes les parties concernées comme preuve des communications, commandes, paiements et transactions intervenus entre les parties.
              </p>
            </Card>
          </div>

          <div className="mt-12 text-center">
            <Button size="lg" asChild>
              <a href="/">
                <ArrowLeft className="mr-2 w-4 h-4" />
                Retour à l'accueil
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
